<script setup></script>
<template>
  <div
    class="justify-content-center align-items-center"
    style="padding: 40px 0px; text-align: center"
  >
    <font-awesome-icon :icon="['fas', 'spinner']" spin size="2x" />
  </div>
</template>
